class FaqAccordionComponent extends HTMLElement {
  constructor() {
    super();
    this.allowMultiple = this.dataset.allowMultiple === 'true';
    this.items = [];
  }

  connectedCallback() {
    this.init();
  }

  init() {
    const questions = this.querySelectorAll('.faq-accordion__question');
    
    questions.forEach((question, index) => {
      const item = question.closest('.faq-accordion__item');
      const answer = item.querySelector('.faq-accordion__answer');
      
      this.items.push({ question, item, answer });
      
      question.addEventListener('click', () => this.toggleItem(index));
    });
  }

  toggleItem(index) {
    const currentItem = this.items[index];
    const isActive = currentItem.item.classList.contains('is-active');

    if (!this.allowMultiple && !isActive) {
      this.items.forEach((item, i) => {
        if (i !== index) {
          this.closeItem(item);
        }
      });
    }

    if (isActive) {
      this.closeItem(currentItem);
    } else {
      this.openItem(currentItem);
    }
  }

  openItem(item) {
    item.item.classList.add('is-active');
    item.question.setAttribute('aria-expanded', 'true');
    item.answer.setAttribute('aria-hidden', 'false');
    item.answer.style.maxHeight = item.answer.scrollHeight + 'px';
  }

  closeItem(item) {
    item.item.classList.remove('is-active');
    item.question.setAttribute('aria-expanded', 'false');
    item.answer.setAttribute('aria-hidden', 'true');
    item.answer.style.maxHeight = '0';
  }
}

customElements.define('faq-accordion-component', FaqAccordionComponent);